import React, { useEffect, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { rootState } from "../../../../redux/store";
import { IBasicDetails, INodeWithPath, IStagingList } from "../../../../interface/interfaces";
import { Subwindow } from "../../../layout/Subwindow/Subwindow";
import { DashboardListMain } from "./DashboardListMain";
import { DashboardCard } from "../DashboardCard";
import { ROUTES } from "../../../../constants/constants";
import { generateColorValues } from "../../../../utils/generateColorValues";
import useUpdatedStagingData from "../DashboardStaging/hooks/useUpdatedStagingData";
import { LoaderBackground } from "../../../shared/LoaderBackground/LoaderBackground";
import { clearNodeInfo } from "../../Tree/nodeInfo.slice";
import { dashboardStatusBarPending } from "./dashboardStatusBar.slice";
import { Loader } from "../../../shared/Loader/Loader";
import { RelativeCenter } from "../../../layout/RelativeCenter/RelativeCenter";
import { triggerDashboardFunc } from "../../../../slices/triggerAnything";
import { fetchStagingDataPending } from "../DashboardStaging/staging.slice";


export const DashboardList = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    
    const {dataAllChildrensPerNode} = useAppSelector((state: rootState)=>state.filteredChildrenNodesPerSelection);
    const {dashboardNodeType} = useAppSelector((state: rootState)=>state.dashboardNodeType);
    const {userAndTokenData} = useAppSelector((state: rootState)=>state.loginUserAndTokenData);
    const {dashboardStatusBarData, dashboardStatusBarError, dashboardStatusBarLoading} = useAppSelector((state: rootState)=>state.dashboardStatusBar);

    
    const {display} = useAppSelector((state: rootState)=>state.dashboardListDisplay);
    const { project } = useAppSelector((state: rootState) => state.project);

    const { stagingLoading, stagingError, updatedList, stagingData} = useUpdatedStagingData()

    
    const dataList: IBasicDetails[] = useMemo(() => {
        return dashboardNodeType === 'tree'
            ? (typeof dashboardStatusBarData !== 'string' ? dashboardStatusBarData : []) 
            : updatedList;
    }, [dashboardNodeType, dashboardStatusBarData, updatedList]);

    // console.log('DATA LIST: ', updatedList);

    const filteredDataList = useMemo(() => {
        return dataList.filter(node => node.Name.toLowerCase().includes(''));
    }, [dataList]);


    const colorMap = useMemo(() => {
        return (dataList as INodeWithPath[]).reduce((acc, node) => {
            acc[node.Id] = generateColorValues();
            return acc;
        }, {} as Record<string, ReturnType<typeof generateColorValues>>);
    }, [dataList]);

    const handleCardClick = (node: IBasicDetails) => {
        // clear node info because of location search param change a bit slower
        dispatch(clearNodeInfo());
        navigate(`/${ROUTES.CONFIGURATION}/${project?._id}/${ROUTES.DASHBOARD}/node?nodeId=${node.Id}`, {
            state: {node, colorValues: colorMap[node.Id]}
        });
    };



    useEffect(()=>{
        if (project?._id && userAndTokenData?.token) {
            dispatch(dashboardStatusBarPending({url:`${ROUTES.PROJECT}/${project._id}/${ROUTES.DASHBOARD_STATUS}`, token:userAndTokenData.token, body:dataAllChildrensPerNode.map(item=>item.Id)}));
        } else {
            console.error("Project ID or user token is missing.");
        }
    }, [dataAllChildrensPerNode])




    const articleList = filteredDataList
    // .filter(item => {
    //     const ok = item.StatusBar?.Ok ?? 0;
    //     const warning = item.StatusBar?.Warning ?? 0;
    //     const error = item.StatusBar?.Error ?? 0;
    //     const unknown = item.StatusBar?.Unknown ?? 0;
        
    //     const total = ok + warning + error + unknown;

    //     return total > 0
    // })
    .map((node: IBasicDetails, idx: number) => {
        return (
            <li key={idx} style={{listStyle:'none'}}>
                <DashboardCard display={display} node={node} idx={idx} handleCardClick={handleCardClick} hasDragIcon={dashboardNodeType === "inBox"}/>
            </li>
        )
    })

    return (
        <>
            {/* {
                !stagingLoading 
                && 
                <Loader height={24} width={24} color="accent-green" label="Getting InBox nodes..."/>
                // <LoaderBackground label='Getting InBox nodes...'/>
            } */}
            
            <Subwindow
                headerSettings={false}
                isSingle={true}
                title={'Dashboard list'}
                footer={<></>}
                mainColor="white"
                main={
                    <>
                        {
                            stagingLoading
                            ?
                            <RelativeCenter>
                                <Loader height={24} width={24} color="accent-green" label="Getting InBox nodes..."/>
                            </RelativeCenter>
                            :
                            <DashboardListMain display={display} articleList={articleList}/>
                        }
                    </>
                }
            />
        </>
    )
}